import { render, staticRenderFns } from "./AdditionalTab.vue?vue&type=template&id=cc9bbb2c&scoped=true"
import script from "./AdditionalTab.vue?vue&type=script&lang=js"
export * from "./AdditionalTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9bbb2c",
  null
  
)

export default component.exports